import React, { useEffect, useState } from 'react';
import { CustomDialog } from '../../../custom-forms';
import { Box, TextField } from '@material-ui/core';
import { TextValidator } from 'react-material-ui-form-validator';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { CaseCalculationPart } from '../../../interfaces/Case';
import { IReferential } from '../../../interfaces/IReferential';
import { useTranslate } from '../../../hooks/useTranslate';

export interface CalculationNotifySupportDialogProps {
  open: boolean;
  part: CaseCalculationPart | null;
  qualities: IReferential[];
  isLoading: boolean;
  onClose: () => void;
  onSend: (part: CaseCalculationPart) => Promise<void>;
}

const CalculationNotifySupportDialog: React.FC<CalculationNotifySupportDialogProps> = ({
  open,
  part,
  qualities,
  isLoading,
  onClose,
  onSend
}) => {
  const t = useTranslate();
  const [comment, setComment] = useState('');

  useEffect(() => {
    if (open) setComment(part && part.supportComment ? part.supportComment : '');
  }, [open, part]);

  const submit = () => onSend({ ...part!, supportComment: comment });

  if (!part) return null;

  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      onSubmit={submit}
      title={t('NOTIFY_SUPPORT_TITLE', 'Notificare pentru verificarea codului o.e')}
      cancelLabel={t('ALT_CALC_CANCEL', 'Renunță')}
      confirmLabel={t('NOTIFY_SUPPORT_SEND_BUTTON', 'Trimite')}
      isLoading={isLoading}
    >
      <Box mb={2}>
        <TextField
          variant="outlined"
          fullWidth
          disabled
          id="name"
          label={t('CALCULATION_DETAILS_DESCRIPTION_HEADER', 'Descriere')}
          value={part.name}
        />
      </Box>

      <Box mb={2}>
        <TextField
          variant="outlined"
          fullWidth
          disabled
          id="guideNumber"
          label={t('CALCULATION_DETAILS_GUIDE_NUMBER_HEADER', 'Cod OE')}
          value={part.guideNumber}
        />
      </Box>

      <Box mb={2}>
        <TextField
          variant="outlined"
          fullWidth
          disabled
          id="originalPrice"
          label={t('CALCULATION_DETAILS_UNIT_PRICE_HEADER', 'Pret Unitar')}
          value={part.originalPrice}
        />
      </Box>

      <Box mb={2}>
        <Autocomplete
          disabled
          fullWidth
          options={qualities}
          value={part.carPartCategory ?? null}
          getOptionLabel={(o: IReferential) => o.displayName}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              fullWidth
              label={t('CALCULATION_DETAILS_QUALITY_HEADER', 'Calitate')}
            />
          )}
        />
      </Box>

      <Box mb={2}>
        <TextValidator
          variant="outlined"
          fullWidth
          multiline
          rows={2}
          disabled={isLoading}
          id="supportComment"
          name="supportComment"
          label={t('CALCULATION_DETAILS_SUPPORT_COMMENT', 'Descriere problema')}
          placeholder={t(
            'CALCULATION_DETAILS_SUPPORT_COMMENT_MESSAGE_PLACEHOLDER',
            'Descriere problema...'
          )}
          value={comment}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setComment(e.target.value)}
          validators={['required']}
          errorMessages={[t('VALIDATORS_REQUIRED', 'Campul este obligatoriu')]}
        />
      </Box>
    </CustomDialog>
  );
};

export default CalculationNotifySupportDialog;
